<template>
  <card-item
    card="item_category"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['variants'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
        {
          title: "Подкатегории",
          key: "categories",
          component: () => import("./Categories"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>